import React from 'react';

export const checkAccessibility = async () => {
  if (process.env.NODE_ENV !== 'production') {
    const axe = (await import('@axe-core/react')).default;
    const ReactDOM = (await import('react-dom')).default;
    await axe(React, ReactDOM, 1000);
  }
};
